import React from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { StaticQuery, graphql } from 'gatsby';
import ReactMarkdown from "react-markdown"

import Calendly from '@components/calendly/book-a-call';

/**
 * Components
 */
import Relative from '@components/relative/relative';
import BackgroundImage from 'gatsby-background-image-es5';

const BookVideoEle = (props) => {
  return (
    <Relative background="#3E1052">
      <Container>
        <Row className="booking">
          <Col lg={4} className="booking__text align-self-center">
            <ReactMarkdown source={props.data.strapiGlobalConfig.Global_Book_A_Video_Call_Content} />
            <Calendly url={props.data.strapiGlobalConfig.Calendly_Link}/>
          </Col>
          <Col className="is-static booking__image" lg={8}>
            <div className="image-holder">
              <BackgroundImage
                  Tag="section"
                  fluid={props.data.strapiGlobalConfig.Global_Book_A_Video_Call_Image.childImageSharp.fluid}
                  style={{width: '55%'}}
                  className="image__inner"
                  fadeIn={true}
                />
            </div>
          </Col>
        </Row>
      </Container>
    </Relative>
  )
}

export default function BookVideo() {
  return (
    <StaticQuery
      query={graphql`
      query {

        strapiGlobalConfig {
          Calendly_Link
          Global_Book_A_Video_Call_Content
          Global_Book_A_Video_Call_Image {
            childImageSharp {
              fluid(maxWidth: 800){
                ...GatsbyImageSharpFluid
              }
            }
          }
        }

      }
    `}
      render={data => <BookVideoEle data={data} />}
    />
  )
}